import * as React from "react";
import { useSelector } from "react-redux";

import { Grid, Button, Table, Loader } from "semantic-ui-react";

import { ApplicationState } from "../../../applicationState";
import { teamsSelector } from "../selectors";

import { Link } from "redux-little-router";

export const All = () => {
    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const teams = useSelector(teamsSelector);
    if (teams === undefined) {
        return <Loader active />;
    }

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Customer Teams</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Members</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell />
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {teams
                                .map(team => (
                                    <Table.Row key={team.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${team.id}`}>
                                                {team.name}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {team.members.length}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
